<template>
  <div class="items-center flex justify-center">
    <ViceButton
      data-cy="run-test-session"
      medium
      :loading="false"
      :class="{ 'pointer-events-none opacity-60': creating }"
      @click="runTestSession"
    >
      {{ creating ? 'Preparing a test session...' : 'Run a test session' }}
    </ViceButton>
  </div>

  <SessionEntryPrecheckWizard
    v-if="testSession"
    :devices="devices"
    :session="testSession"
    :precheckOpen="isPrecheckOpen"
    @openSessionEntryWizard="enterTestSession"
    @closeSessionEntryPrecheckWizard="cancelTestSession"
  />
</template>

<script>
import SessionEntryPrecheckWizard from '@/Pages/User/Details/SessionEntryPrecheckWizard.vue';
import ViceButton from '@/Components/Buttons/ViceButton.vue';

export default {
  name: 'RunTestSession',
  components: {
    ViceButton,
    SessionEntryPrecheckWizard,
  },
  data() {
    return {
      creating: false,
      entering: false,
      testSession: null,
      isPrecheckOpen: false,
    };
  },
  computed: {
    devices() {
      return {
        video: this.testSession?.clinician_devices ?? [],
        audio: this.testSession?.clinician_default_devices ?? [],
      };
    },
  },
  methods: {
    async runTestSession() {
      if (this.creating) return;
      this.creating = true;
      try {
        const { data } = await axios.post(route('store.test-session'));
        this.testSession = data.session;
        this.entering = false;
        this.isPrecheckOpen = true;
      } catch (error) {
        console.error('Error creating a test session:', error);
      } finally {
        this.creating = false;
      }
    },
    enterTestSession() {
      this.entering = true;
      window.open(
        route('session.clinician.show', { unique_id: this.testSession.unique_id }),
        '_blank',
      );
    },
    cancelTestSession() {
      this.isPrecheckOpen = false;
      if (!this.entering && this.testSession) {
        axios.post(route('delete.session', this.testSession.unique_id));
        this.testSession = null;
      }
    },
  },
};
</script>
